<template>
  <div>
    <base-info ref="baseInfo" v-loading="loading" />
    <div class="box">
      <CreditExtensionAttachment
        ref="creditExtensionAttachment"
        v-loading="loading"
      />
      <ApplyAttachment ref="applyAttachment" v-loading="loading" />
      <HistoricalApproval ref="historicalApproval" v-loading="loading" />
    </div>
    <div class="rj-page-card" style="text-align: center">
      <div class="rj-page-card__content">
        <el-button class="btn-style" :loading="loading" @click="backClick">
          返回
        </el-button>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from './components/baseInfo.vue';
import CreditExtensionAttachment from './components/creditExtensionAttachment.vue';
import ApplyAttachment from './components/applyAttachment.vue';
import HistoricalApproval from './components/historicalApproval.vue';
import { getCreditControl } from '@/API/creditAxios.js';
export default {
  data () {
    return {
      loading: false
    };
  },
  components: {
    baseInfo,
    CreditExtensionAttachment,
    ApplyAttachment,
    HistoricalApproval
  },
  computed: {},
  methods: {
    async backClick (val) {
      this.$router.push({
        name: 'creditControlApplicationList'
      });
    },
    async initialization () {
      try {
        let params = {
          isControl: false,
          isEdit: false,
          orderId: this.$route.query.orderId,
          isChannelManager: false
        };
        this.loading = true;
        const result = await getCreditControl(params);
        this.loading = false;
        if (result.data.status === '200') {
          this.$refs.baseInfo.setData(result.data.data.creditControlInfo, result.data.data.creditControlDetail);
          this.$refs.creditExtensionAttachment.setData(result.data.data.enhancementAttachmentList || []);
          this.$refs.applyAttachment.setData(result.data.data.applicantAttachmentList || []);
          this.$refs.historicalApproval.setData(result.data.data.approvalHistoryVOS || []);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted () {
    this.initialization();
  }
};
</script>
<style lang="scss" scoped>
.btn-style{
  width: 120px;
  height: 42px;
  font-size: 16px;
}

.box{
  background-color: #fff;
  padding: 10px;
}
</style>
